import React from "react";
import '../../CSS/Cooperation.css';
import LienCooperation from "../composant_reutilisable/LienCooperation";

const Cooperation_multilaterales = () => {
    return (
        <div className="cooperation-container">
            <div className="cooperation-content">
                <div className="cooperation-texte">
                    <div className="cooperation-paragraphe">
                        <h4>Défendre les intérêts du Bénin au cœur de la diplomatie mondiale </h4>

                        <p>
                            L’Ambassade du Bénin en France est également chargée de représenter notre pays auprès des grandes organisations internationales et institutions spécialisées établies en Europe. Point d’ancrage multilatéral, Paris permet de porter la voix du Bénin dans les enceintes où se négocient les réponses aux défis globaux : paix et sécurité, développement durable, innovation, culture ou droits humains.
                            <br />
                            L’Ambassade contribue à défendre les positions du Bénin, à participer aux travaux collectifs et à promouvoir une présence cohérente de notre pays dans les instances internationales. Cette mission est conduite en étroite coordination avec le Ministère des Affaires étrangères et les ministères sectoriels concernés afin d’assurer un suivi efficace et de transformer la coopération multilatérale en résultats concrets pour le Bénin.
                        </p>


                    </div>
                </div>
            </div>
            <LienCooperation />
        </div>
    );
};

export default Cooperation_multilaterales;